import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyAqcCinazDfzgqfY-R_j5yfM37v1KAUBnw",
//   authDomain: "fendova-ats.firebaseapp.com",
//   databaseURL: "https://fendova-ats-default-rtdb.firebaseio.com",
//   projectId: "fendova-ats",
//   storageBucket: "fendova-ats.firebasestorage.app",
//   messagingSenderId: "1063010302487",
//   appId: "1:1063010302487:web:22997b685c5d815789ba52",
//   measurementId: "G-QMC2E79MJX"
// };

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB7nEYrYnhKk7kOpgpyeZ82Ipmmt6mNecU",
  authDomain: "pinwheelaigpt.firebaseapp.com",
  projectId: "pinwheelaigpt",
  storageBucket: "pinwheelaigpt.firebasestorage.app",
  messagingSenderId: "845032443859",
  appId: "1:845032443859:web:f3c9f328bcd60bddb8e926",
  measurementId: "G-T2EK1G6TH3"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const rtdb = getDatabase(app);  // Export Realtime Database